import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Row, Col, Checkbox, message, InputNumber, Select} from 'antd';

import {
    fetchContractorSettings,
    addContractorSetting,
    deleteContractorSetting,
    updateContractorSetting
} from '../../../actions';

const Option = Select.Option;

class Settings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serverErrors: null
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const {settings: {isFetching, error}} = nextProps;
        if (isFetching) {
            return null;
        }

        if (error) {
            return {...prevState, serverErrors: error}
        }
        if (!error && prevState.serverErrors) {
            return {...prevState, serverErrors: null}
        }

        return null;
    }
    static notifySuccess() {
        message.success('Successfully updated')
    }
    static notifyError(errors) {
        const errs = typeof errors === 'string' ? errors : Object.keys(errors).map(key => errors[key].map((e, i) => <span key={i}>{e}</span>));
        message.error(errs);
    }
    handlePostSubmit() {
        const {state: {serverErrors}} = this;
        if (!serverErrors) {
            Settings.notifySuccess();
            return;
        }

        const {res: {errors, message}} = serverErrors;
        Settings.notifyError(errors || message);
    }
    componentDidMount() {
        const {landlord: {id}, fetchContractorSettings} = this.props;
        return fetchContractorSettings(id)
    }
    render() {
        const {settings: {data, isFetching}, addContractorSetting, deleteContractorSetting, updateContractorSetting, landlord: {id}} = this.props;
        const onToggle = field => e => {
            const {checked} = e.target;
            const method = checked ? addContractorSetting : deleteContractorSetting;
            return method(id, field).then(() => this.handlePostSubmit());
        };
        const onChange = (field, config) => e => {
            const method = config ? updateContractorSetting : addContractorSetting;
            field = config ? config.id : field;
            return method(id, field, e.target.value).then(() => this.handlePostSubmit());
        };
        const onSelect = (field, config) => (value) => {
            const method = config ? updateContractorSetting : addContractorSetting;
            field = config ? config.id : field;
            return method(id, field, value).then(() => this.handlePostSubmit());
        };

        const renderBooleanSetting = ({name = '', id = '', config = null}) => (
            <Row key={id}>
                <Col span={6}><p>{name} </p></Col>
                <Col span={2}><Checkbox checked={!!config} onChange={onToggle(id)}/></Col>
            </Row>
        );

        const renderIntegerSetting = ({name = '', id = '', config = null}) => (
            <Row key={id}>
                <Col span={8}><p>{name} </p></Col>
                <Col span={2}><InputNumber size="small" defaultValue={config && config.integer_value} onBlur={onChange(id, config)}/></Col>
            </Row>
        );

        const renderMultiSelectSetting = ({name = '', id = '', config = null, options = []}) => {
            options = options.map(({id, name}) => (
                <Option key={id} value={id}>{name}</Option>
            ));
            const value = config ? config.options.map(i => i.option_id) : [];
            return (
                <Row key={id}>
                    <Col span={8}><p>{name} </p></Col>
                    <Col span={16}>
                        <Select
                            style={{ width: '100%' }}
                            mode="multiple"
                            placeholder="Please select"
                            onChange={onSelect(id, config)}
                            value={value}
                        >
                            {options}
                        </Select>
                    </Col>
                </Row>
            )
        };

        return (
            <div>
                <Card title="Business Settings" loading={isFetching} bordered={false}>
                    <Row gutter={16}>
                        <Col md={{span: 12}}>
                            {data.filter(i => i.type === 'boolean' && i.section === 'business').map(renderBooleanSetting)}
                        </Col>
                        <Col md={{span: 12}}>
                            {data.filter(i => i.type === 'multi-select' && i.section === 'business').map(renderMultiSelectSetting)}
                        </Col>
                    </Row>
                </Card>
                <Card title="Engineer Settings" loading={isFetching} bordered={false}>
                    <Row gutter={16}>
                        <Col md={{span: 12}}>
                            {data.filter(i => i.type === 'boolean' && i.section === 'engineer').map(renderBooleanSetting)}
                        </Col>
                        <Col md={{span: 12}}>
                            {data.filter(i => i.type === 'integer').map(renderIntegerSetting)}
                        </Col>
                    </Row>
                </Card>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        settings: state.landlord.contractorSettings,
        landlord: state.me.application
    }
};
export default connect(mapStateToProps, {
    fetchContractorSettings,
    addContractorSetting,
    deleteContractorSetting,
    updateContractorSetting
})(Settings);


// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/contractor/Settings.js